import React from 'react';
import PropTypes from 'prop-types';
import DisclaimerText from './DisclaimerText';

const Payment = ({
	payment,
	hasTerm,
	dataPreloadAttr = null,
	hasTaxesAndFees = false
}) => {
	const paymentSpanProps = {
		key: 'payment',
		className: 'font-weight-bold ddc-font-size-base'
	};

	if (dataPreloadAttr) {
		paymentSpanProps['data-preload'] = dataPreloadAttr;
	}

	return (
		<>
			<span {...paymentSpanProps} key='payment'>{payment}</span>
			{hasTerm && (
				<DisclaimerText
					text=' / mo'
					key="payment-term"
				/>
			)}
			{hasTaxesAndFees && (
				<DisclaimerText key="taxes-fees-asterisk" text="*" isSuperscript={!hasTerm} />
			)}
		</>
	);
};

Payment.propTypes = {
	payment: PropTypes.string.isRequired,
	hasTerm: PropTypes.bool,
	dataPreloadAttr: PropTypes.string,
	hasTaxesAndFees: PropTypes.bool
};

export default Payment;
